import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import toast from "react-hot-toast";
import ComponentBackdrop from "../../components/backdrop";

export default function PointModal({
  open,
  onClose,
  onSave,
  initialData, // optional: { type: "add" | "deduct", totalPoint: number, remark: string }
}) {
  const [inputForm, setInputForm] = useState({
    type: "add",
    totalPoint: "",
    remark: "",
  });
  const [errors, setErrors] = useState({});
  const [openBackdrop, setOpenBackdrop] = useState(false);

  useEffect(() => {
    if (open) {
      setInputForm({
        type: initialData?.type ?? "add",
        totalPoint:
          initialData?.totalPoint != null
            ? Math.abs(Number(initialData.totalPoint)).toString()
            : "",
        remark: initialData?.remark ?? "",
      });
      setErrors({});
    }
  }, [open, initialData]);

  const validate = () => {
    const next = {};
    if (!inputForm.type) next.type = "Type is required.";
    if (inputForm.totalPoint === "") next.totalPoint = "Total point is required.";
    else if (isNaN(Number(inputForm.totalPoint))) next.totalPoint = "Must be a number.";
    else if (Number(inputForm.totalPoint) <= 0) next.totalPoint = "Must be greater than 0.";
    if (!inputForm.remark?.trim()) next.remark = "Remark is required.";
    setErrors(next);
    return Object.keys(next).length === 0;
  };

    const handleInputChange = (property, event) => {
    // console.log("value", event.target.value);
    const value = event.target.value;
    setInputForm((prevState) => ({
      ...prevState,
      [property]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const points = Math.abs(Number(inputForm.totalPoint));
    const signedPoints = inputForm.type === "deduct" ? -points : points;
    setOpenBackdrop(true);

    const timer = setTimeout(() => {
      setOpenBackdrop(false);
      toast.success("Department is created"); 
      onClose();
    }, 3000);
    // onSave?.({
    //   type: inputForm.type,              // "add" | "deduct"
    //   totalPoint: signedPoints,     // signed integer
    //   remark: inputForm.remark.trim(),
    // });
    // onClose?.();
  };

  const renderField = ( label, id, type = "text", select = false, options = [], disabled = false ) => (
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 1,
            mb: 2,
          }}
        >
          <Typography
            sx={{
              minWidth: { sm: 150 },
              alignSelf: { sm: "center" },
            }}
          >
            {label}
          </Typography>
          <TextField
            id={id}
            type={type}
            select={select}
            disabled={disabled}
            error={!!errors[id]}
            helperText={errors[id]}
            onChange={(e) => handleInputChange(id, e)}
            value={inputForm[id]}
            required
            fullWidth
            size="small"
            variant="outlined"
          >
            {select &&
              options.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
          </TextField>
        </Box>
      );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ component: "form", onSubmit: handleSubmit }}>
      <DialogTitle>Add / Deduct Points</DialogTitle>
      <ComponentBackdrop openBackdrop={openBackdrop} />

      <DialogContent dividers sx={{ pt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {/* <TextField
              select
              label="Type"
              name="type"
              value={form.type}
              onChange={handleChange}
              error={!!errors.type}
              helperText={errors.type}
              fullWidth
              size="small"
            >
              <MenuItem value="add">Add point</MenuItem>
              <MenuItem value="deduct">Deduct point</MenuItem>
            </TextField> */}
            {renderField("Type", "type", "text", true, [
                        { value: "add", label: "Add point" },
                        { value: "deduct", label: "Deduct point" },
                    ])}
                                        {renderField("Total Point", "totalPoint")}
                                        {renderField("Remark", "remark")}


          </Grid>

          {/* <Grid item xs={12}>
            <TextField
              label="Total point"
              name="totalPoint"
              value={form.totalPoint}
              onChange={handleChange}
              error={!!errors.totalPoint}
              helperText={errors.totalPoint || "Enter a positive number"}
              fullWidth
              size="small"
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Remark"
              name="remark"
              value={form.remark}
              onChange={handleChange}
              error={!!errors.remark}
              helperText={errors.remark}
              fullWidth
              size="small"
              multiline
              minRows={2}
            />
          </Grid> */}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 2.5 }}>
        <Button onClick={onClose} variant="text">Cancel</Button>
        <Button type="submit" variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
}
